import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Romantic%20anime%20style%20illustration%20with%20two%20elegant%20male%20figures%20in%20flowing%20traditional%20Chinese%20robes%20under%20cherry%20blossom%20trees%2C%20soft%20ethereal%20atmosphere%2C%20golden%20and%20pink%20warm%20tones%2C%20starry%20night%20sky%2C%20dreamy%20romantic%20scene%2C%20high%20quality%20anime%20art%2C%20beautiful%20composition%2C%20soft%20lighting%2C%20danmei%20aesthetic&width=1800&height=1000&seq=hero-bg-danmei-01&orientation=landscape"
        alt="耽美漫画网 - 免费耽美漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
            耽美漫画网
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-3 max-w-xl mx-auto leading-relaxed">
            海量<strong className="text-white font-medium">免费耽美漫画</strong>与<strong className="text-white font-medium">免费BL漫画</strong>，高清在线免费阅读
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-lg mx-auto">
            每日更新热门免费耽美资源，满足零成本追漫需求
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/xiao-yuan"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-full text-sm font-medium hover:bg-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">1000+</p>
              <p className="text-xs text-white/60 mt-1">精品漫画</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">每日更新</p>
              <p className="text-xs text-white/60 mt-1">从不间断</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">完全免费</p>
              <p className="text-xs text-white/60 mt-1">零成本追漫</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}